(function () {
    'use strict';

    angular.module('document')
        .controller('DocumentController', [
            '$scope',
            'DocumentService',
            'userService',
            documentController]);

    function documentController($scope, DocumentService) {
        $scope.object = DocumentService.getCurrentObject();
    }

})();
